// 所有的请求都放在该目录
import instance from "../utils/request";

export const UPLOAD_FILE_PATH = 'https://www.ccxy.space/'
/**
 * 首页 
 */
//获取租户信息
export function getRentInfo(data) {
    return instance({
        url: '/api/home/getRentInfo',
        method: 'post',
        data
    })
}
//首页数据
export function getHomeData(data) {
    return instance({
        url: '/api/home/getHomeData',
        method: 'post',
        data
    })
}
//菜单
export function getmenuList(data) {
    return instance({
        url: '/api/home/getMenuList',
        method: 'post',
        data
    })
}
/**
 * 案例
 */
 export function getCaseDictList(data) {
    return instance({
        url: '/api/case/getCaseDictList',
        method: 'post',
        data
    })
}
export function getCaseList(data) {
    return instance({
        url: '/api/case/getCaseList',
        method: 'post',
        data
    })
}
export function getCaseDetailList(data) {
    return instance({
        url: '/api/case/getCaseDetailList',
        method: 'post',
        data
    })
}
/**
 * 活动
 */

 export function getActivityList(data) {
    return instance({
        url: '/api/activity/getActivityList',
        method: 'post',
        data
    })
}
export function getActivityDetailList(data) {
    return instance({
        url: '/api/activity/getActivityDetailList',
        method: 'post',
        data
    })
}
/**
 * 简介
 */
 export function getRentDetailList(data) {
    return instance({
        url: '/api/rent/getRentDetailList',
        method: 'post',
        data
    })
}
/**
 * 设计师
 */
 export function getDesignerDictList(data) {
    return instance({
        url: '/api/designer/getDesignerDictList',
        method: 'post',
        data
    })
}
export function getDesignerList(data) {
    return instance({
        url: '/api/designer/getDesignerList',
        method: 'post',
        data
    })
}
export function getDesigner(data) {
    return instance({
        url: '/api/designer/getDesigner',
        method: 'post',
        data
    })
}
export function insertReservation(data) {
    return instance({
        url: '/api/insertReservation',
        method: 'post',
        data
    })
}

export function selectRentTitleList(data) {
    return instance({
        url: '/api/selectRentTitleList',
        method: 'post',
        data
    })
}